import { uid } from "@xbs/lib-state";
import moveCard from "./move";
import { getAreaId } from "../../helpers";
export default function (store, ev) {
    const card = ev.card || {};
    const id = ev.id || card.id || uid();
    const state = store.getState();
    const columnKey = state.columnKey;
    const rowKey = state.rowKey;
    const rowId = ev.rowId || (rowKey && card[rowKey]) || state.rows[0].id;
    const columnId = ev.columnId || card[columnKey] || state.columns[0].id;
    if (state.areasMeta[getAreaId(columnId, rowId)].noFreeSpace) {
        return false;
    }
    const cardObj = {
        [columnKey]: columnId,
        label: "Untitled",
        id,
        ...card,
    };
    if (rowKey) {
        cardObj[rowKey] = rowId;
    }
    state.cards.push(cardObj);
    const { cardsMap, areasMeta } = store.getInnerState(state);
    store.setState({ ...state, cardsMap, areasMeta });
    if (ev.before) {
        moveCard(store, { ...ev, id });
    }
    if (ev.select !== false) {
        store.in.exec("select-card", { id });
    }
    ev.card = cardObj;
    ev.id = id;
    return () => {
        store.in.exec("delete-card", { id, $meta: { skipHistory: true } });
    };
}
//# sourceMappingURL=add.js.map